import {createPortal} from "react-dom";
import React, {useCallback, useMemo, memo, useEffect, useState} from "react";
import { Drawer, Spin } from "antd";
import {FormContext, WscCustomForm} from "wsc-react-custom-form";

import useRequest from "@/utils/useRequest";
import { useCommonStore } from "@/store/useCommonStore";
import { useEditorStore } from "@/store/useEditorStore";
import Config from "@/config";
import useWscCustomFormModal from '@/component/UseWscCustomForm';
import { nanoid } from 'nanoid'
import {
    FormCode, FlowDict, FormNodeSwitch
} from '@/component/exComponents';

export function DictDetail({display, onClose, forType, idFlag}) {
    const { request } = useRequest();

    const [loading, setLoading] = useState(false);
    const [schema, setSchema] = useState(undefined);
    const sysdicts = useCommonStore.use.sysdicts();

    const addNode = useEditorStore.use.addNode();
    const updateNodeProps = useEditorStore.use.updateNodeProps();
    const registerNodes = useEditorStore.use.registerNodes();
    const node_map = useEditorStore.use.node_map();
    const nodes = useEditorStore.use.nodes();
    const id = useMemo(()=> idFlag ?? nanoid(), [idFlag]);
    let registerNode = registerNodes.find(item => item.type === forType);
    const targetNode = idFlag ? node_map[id] : {
        id: nanoid(),
        props: {
            wires: [],
            ...(registerNode?.props ?? {}),
        }
    };
    // console.log('registerNode', registerNode);
    // console.log('targetNode', targetNode);
    // console.log('node_map', node_map);
    // console.log('nodes', nodes);

    const loadSchema = useCallback(async (id) => {
        setLoading(true);
        const result = await request("/api/v2/private/dynamicform/schema/get", "POST", "json", { id: id });
        setLoading(false);
        if (result.success) {
            setSchema(result.data.Data);
        }
        return null;
    }, []);

    const onPayload = (form, name, data) => {
        console.log('payload', 'form', form, 'name', name, 'data', data);
        if ('cancel' === name?.toLowerCase()) {
            onClose();
            return;
        }
        if ('ok' === name?.toLowerCase()) {
            // state.node_map[nodeData.id].props = nodeData.props;
            // state.node_map[nodeData.id].name = nodeData.name;
            // state.node_map[nodeData.id].outputs = nodeData.outputs;
            const result = {
                ...targetNode,
                ...data,
                props: {
                    ...targetNode?.props ,
                    ...data?.props,
                },
                type: forType,
            } ;
            console.log('add/update node', result);

            // 新增和更新
            if (!idFlag) {
                addNode(result)
            } else {
                updateNodeProps(result);
            }
            onClose();
        }
    };


    // const { showDynamicModal, hide, WscCustomFormModal } = useWscCustomFormModal();
    useEffect(() => {loadSchema(registerNode.formid);}, [registerNode]);

    if (!display) return null;

    return (
        <>
            {
                createPortal(
                    <Drawer
                        placement="right"
                        onClose={onClose}
                        open={display}
                        loading={loading}
                        size='large'
                    >
                        { schema ? (
                            <WscCustomForm
                                schema={schema}
                                OnPayload={onPayload}
                                exComponents={[ FormCode, FlowDict, FormNodeSwitch ]}
                                formdata={targetNode}
                                sysdicts={sysdicts}
                                baseURL={Config.ApiHost}
                            />
                        ): (
                            <Spin />
                        )}

                    </Drawer>,
                    document.body,
                )
            }
        </>
    );

}

// DictDetail.whyDidYouRender = true;
export default memo(DictDetail);
// export default DictDetail;
